import DpEventBus from './dp-event-bus';
import VueEvents from './vue-events';
import VueDefinitions from './vue-definitions';
import documentReady from '@webapp-next/lib/document-ready';
import peopleGlobalRetroFeed from '@webapp-next/modules/people/global-retro-feed';
import { classicRouterRetrofeed } from '@webapp-next/router/classic';
import createI18n from '@webapp-next/lib/i18next/createI18n';
import PreferencesV2 from '@webapp-next/lib/request/webapp/user/preferences';
import checkFF from '@webapp-next/lib/feature-flag';
import {
  trackForInstall,
  trackForInstallLegacyModel,
  identifyAnalyticsUser,
} from '@/lib/tracking';
import SupportService from '@/lib/support';
import userHasPermission from '@/lib/user-has-permission';
import hasMultipleLocationSelected from '@/modules/schedule/composables/roster/has-multiple-location-selected';
import {
  getRootDeputyFrame,
  isWindowDeputyRootFrame,
} from '@webapp-next/global-libs/deputy-embed';
import { initIframeAiContextBridge } from './iframe-ai-context-bridge';
import { setupAiContextRegistry } from '@deputyapp/deputy-ai/context-registry';
import peopleEmployeesGet from '@webapp-next/lib/request/webapp/people/employees-get';
import classicBootstrapPromiseInitialize from '@/global-libs/classic-bootstrap-promise';
import { getDapContext as helpCenterGetDapContext } from '@/lib/request/webapp/help-centre/get-dap-context';
import './modules/schedule';

// leave
import leaveCheckIsLeaveManagementEnabled from '@apps-leave/composables/check-is-leave-management-enabled';

// locations
import { getCountryList as locationsGetCountryList } from '@webapp-next/apps/locations/src/requests/getCountryList';

// TODO: this will be the future place of this lib
// import initializeSegment from '@webapp-next/lib/segment';

// TODO: this will be the future place of this lib
// if (window.__APP__?.ANALYTICS?.segmentKey) {
//   window.__APP__.ANALYTICS.track = initializeSegment(window.__APP__.ANALYTICS);
// }

const isOnce = !window.$dt;

// allow boostrapPromise to work in iframe
if (window.DP) {
  if (!getRootDeputyFrame()?.DP?.BootstrapPromise) {
    classicBootstrapPromiseInitialize();
  }

  window.DP.BootstrapPromise = getRootDeputyFrame()?.DP?.BootstrapPromise!;
}

window.DpEventBus = DpEventBus;

// detect iframe
if (!isWindowDeputyRootFrame()) {
  window.VueEventBus = getRootDeputyFrame()?.VueEventBus?.iframeInstance(
    window.name
  );
} else {
  window.VueEventBus = window.VueEventBus || new DpEventBus();
  // Setup AI context registry - global-libs owns this
  setupAiContextRegistry();
  // Initialize bridge for iframe communication
  initIframeAiContextBridge();
}

// initialize __APP__ namespace if not already present
window.__APP__ = window.__APP__ || {};

// leave module (not available in Once)
if (!isOnce) {
  window.__APP__.LEAVE = window.__APP__.LEAVE || {};
  window.__APP__.LEAVE.request = window.__APP__.LEAVE.request || {};
  window.__APP__.LEAVE.request.isLeaveManagementEnabled =
    leaveCheckIsLeaveManagementEnabled;
}

// locations module
window.__APP__.PEOPLE = window.__APP__.PEOPLE || {};
window.__APP__.PEOPLE.request = window.__APP__.PEOPLE.request || {};
window.__APP__.PEOPLE.request.employeeGet = peopleEmployeesGet;

// locations module
window.__APP__.LOCATIONS = window.__APP__.LOCATIONS || {};
window.__APP__.LOCATIONS.request = window.__APP__.LOCATIONS.request || {};
window.__APP__.LOCATIONS.request.getCountryList = locationsGetCountryList;

// help centre
window.__APP__.HELP_CENTER = window.__APP__.HELP_CENTER || {};
window.__APP__.HELP_CENTER.request = window.__APP__.HELP_CENTER.request || {};
window.__APP__.HELP_CENTER.request.getDapContext = helpCenterGetDapContext;

window.VueEvents = VueEvents;
window.VueDefinitions = VueDefinitions;
window.VueFacades = {
  userHasPermission,
  hasMultipleLocationSelected,
};

window.globalLibs = window.globalLibs || {};

window.globalLibs.i18NextPromise =
  getRootDeputyFrame()?.globalLibs?.i18NextPromise || createI18n();

window.globalLibs.PreferencesV2Service =
  getRootDeputyFrame()?.globalLibs?.PreferencesV2Service || PreferencesV2;

window.globalLibs.trackForInstall = trackForInstall;
window.globalLibs.trackForInstallLegacyModel = trackForInstallLegacyModel;
window.globalLibs.identifyAnalyticsUser = identifyAnalyticsUser;
window.globalLibs.SupportService = SupportService;

// // needs to be here to load it first
if (checkFF('core-0-vue-router')) {
  classicRouterRetrofeed();
}

// initialize content considering FF
async function initializeGlobalLibs(): Promise<void> {
  // necessary "hacks" from new People vue tab to temporarily prevent classic to break
  peopleGlobalRetroFeed();

  if (isWindowDeputyRootFrame()) {
    try {
      await window.globalLibs?.PreferencesV2Service?.getPreferences();
    } catch (e) {
      console.error('globalLibs.PreferencesV2Service.getPreferences', e);
    }
  }
}

documentReady(initializeGlobalLibs);
